export default __webpack_public_path__ + "static/Gmail1-dbe62c93bff2a89994dcaef075152a83.png";